import { LOCAL_STORAGE_KEYS } from '../../../utils/constants/values.constants';
import { saveToLocalStorage } from '../../../utils/utils';
import { bifrostConfig } from '../../../config/bifrost.config';

export const fetchLoggedInUserData = () => async () => {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error('No access token found');
    }

    const response = await fetch(
      `${bifrostConfig.userProfileBaseUrl}/api/v1/user`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch user profile: ${response.status}`);
    }

    const result = await response.json();
    const userGroups = result.data?.roles || [];

    saveToLocalStorage(LOCAL_STORAGE_KEYS.USER_GROUPS, userGroups);
  } catch (e) {
    console.error('Error fetching logged in user data:', e);
    saveToLocalStorage(LOCAL_STORAGE_KEYS.USER_GROUPS, []);
  }
};
